/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ km: NonNullable<unknown> }} Geocelllegend2Inputs */

const en_geocelllegend2 = /** @type {(inputs: Geocelllegend2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`One dot is about ${i?.km} km across.`)
};

const de_geocelllegend2 = /** @type {(inputs: Geocelllegend2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ein Punkt umfasst etwa ${i?.km} km.`)
};

/**
* | output |
* | --- |
* | "One dot is about {km} km across." |
*
* @param {Geocelllegend2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geocelllegend2 = /** @type {((inputs: Geocelllegend2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geocelllegend2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geocelllegend2(inputs)
	return de_geocelllegend2(inputs)
});
export { geocelllegend2 as "geoCellLegend" }